import axios from "axios";

const instance = axios.create({
	headers: { "X-REQUESTED-WITH": "XMLHttpRequest", "Access-Control-Allow-Origin": "*" },
});

instance.interceptors.response.use(
	(config) => {
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default instance;
export const getWebinars = () => instance.get(window.webinars_data.route);
